// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"uU-z","inlineTitle":"vU-z","sponsoredAdsWrapper":"wU-z","marketplaceRecosWrapper":"xU-z"};